import { render, staticRenderFns } from "./RuleRow.vue?vue&type=template&id=845e2e8c&scoped=true&"
import script from "./RuleRow.vue?vue&type=script&lang=js&"
export * from "./RuleRow.vue?vue&type=script&lang=js&"
import style0 from "./RuleRow.vue?vue&type=style&index=0&id=845e2e8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845e2e8c",
  null
  
)

export default component.exports